import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
	post,
	get
} from './utils/http.js'
import domain from './assets/js/domain.js'
import iView from 'iview';
import 'iview/dist/styles/iview.css'; // 使用 CSS


import '@/assets/fonts/font.css'
import '@/assets/css/variables.css'
import '@/assets/css/common.css'
import '@/assets/icons/iconfont.css'


import LoginDialog from '@/components/login/loginDialog.vue';
import registerDialog from '@/components/register/registerDialog.vue';
import forgetPasswordDialog from '@/components/forgetPassword/index.vue';



Vue.config.productionTip = false

//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;

Vue.prototype.domain = domain


Vue.use(iView)

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	if (to.meta.content) {
		let head = document.getElementsByTagName('head');
		let meta = document.createElement('meta');
		document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
		document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
		meta.content = to.meta.content;
		// console.log(meta,to.meta.content)
		head[0].appendChild(meta)
	}
	next()
})

router.afterEach((to, from, next) => { //控制路由跳转时滚动条在顶部
	window.scrollTo(0, 0);
});


// 防止el-button重复点击
Vue.directive('preventReClick', {
	inserted(el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true;
				el.style.cursur = 'not-allowed'
				setTimeout(() => {
					el.disabled = false
					el.style.cursor = 'pointer'
				}, binding.value || 2000)
			}
		})
	}
});

new Vue({
	router,
	store,
	render: h => h(App),
	mounted() {
		// 确保应用已完全加载后再创建并挂载LoginDialog实例
		this.createAndMountLoginDialog();
		this.createRegisterDialog()
		this.createForgetPasswordDialog()
		
	},
	methods: {
		createAndMountLoginDialog() {
			// 创建LoginDialog实例并挂载到DOM
			const loginDialogContainer = document.createElement('div');
			document.body.appendChild(loginDialogContainer);
			new Vue({
				...LoginDialog,
				store, // 确保LoginDialog也能访问Vuex store
				router, // 如果需要的话，也可以传递router
			}).$mount(loginDialogContainer);
		},
		createRegisterDialog() {
			const dialogContainer = document.createElement('div');
			document.body.appendChild(dialogContainer);
			new Vue({
				...registerDialog,
				store, // 确保LoginDialog也能访问Vuex store
				router, // 如果需要的话，也可以传递router
			}).$mount(dialogContainer);
		},
		createForgetPasswordDialog() {
			const dialogContainer = document.createElement('div');
			document.body.appendChild(dialogContainer);
			new Vue({
				...forgetPasswordDialog,
				store, // 确保LoginDialog也能访问Vuex store
				router, // 如果需要的话，也可以传递router
			}).$mount(dialogContainer);
		}
		
	}

}).$mount('#app')